module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "siteService-item-wrapper"
  }, [_c('div', {
    staticClass: "titleArea"
  }, [_c('div', {
    staticClass: "verticalIndicator"
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.title) + "\n\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "servicesItems"
  }, [(!_vm.richText) ? _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "serviceItem"
    }, [_vm._v("\n\t\t\t\t" + _vm._s(item) + "\n\t\t\t")])
  }) : _vm._e(), _vm._v(" "), (_vm.richText) ? _c('div', {
    staticClass: "richText"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.nodesArray)
    }
  })]) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ec703de4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/siteServicesItem.vue
// module id = 242
// module chunks = 1